<template>
  <div class="custom-card flex flex-col gap-4">
    <accordion>
      <accordion-item title="Fleet">
        <div>
          <div class="container-fluid">
            <div class="row my-3 flex flex-row justify-between">
              <div class="my-3">
                <p>Fleet assigned to you</p>
              </div>
              <base-button
                v-if="fleet.length > 0"
                class="my-3"
                text="View Vehicle Particulars"
                @click="showVehicleParticulardModal = true"
              />
            </div>
            <div v-if="fleet.length > 0" class="row">
              <div class="col-md-12 col-lg-12 col-12">
                <div class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="fname" class="label">Vehicle Name</label>
                    <input
                      disabled
                      type="text"
                      class="input"
                      v-model="fleet.equipment"
                      placeholder="-- Enter First Name --"
                    />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="mname" class="label">Vehicle Number</label>
                    <input
                      disabled
                      type="text"
                      class="input"
                      v-model="fleet.vehicleNumber"
                      placeholder="-- Enter Middle Name --"
                    />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="lname" class="label">VIN Number</label>
                    <input
                      disabled
                      type="text"
                      class="input"
                      v-model="fleet.vinnumber"
                      placeholder="-- Enter Last Name --"
                    />
                  </div>
                </div>
                <div class="input-row my-4">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="gender" class="label">Chasis Number</label>
                    <input
                      disabled
                      type="text"
                      class="input"
                      v-model="fleet.vinnumber"
                      placeholder="-- Enter Last Name --"
                    />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="email" class="label">Asset Tag</label>
                    <input disabled type="email" class="input" v-model="fleet.assettag" />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="number" class="label">Vehicle Type</label>
                    <input disabled class="input" v-model="fleet.vehicletype" />
                  </div>
                </div>
                <div class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="fname" class="label">Max Capacity (Tonnage)</label>
                    <input
                      disabled
                      type="text"
                      class="input"
                      v-model="fleet.carriageCapacity"
                      placeholder="-- Enter Adress --"
                    />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="gender" class="label">Load Capacity (Tonnage)</label>
                    <input disabled class="input" v-model="fleet.currentLoadCapacity" />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="mname" class="label">Terminal</label>
                    <input
                      disabled
                      type="text"
                      class="input"
                      v-model="terminal.locationName"
                      placeholder="-- Enter Country --"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-item>
      <accordion-item title="Routes">
        <div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 col-lg-4 col-12">
                <div class="my-3">
                  <p>Routes assigned to you</p>
                </div>
              </div>
              <div v-for="(routesObj, index) in routes" :key="index" class="col-md-12 col-lg-12 col-12">
                <div class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="fname" class="label">Route Type</label>
                    <input
                      type="text"
                      class="input"
                      v-model="routesObj.terminalType"
                      placeholder="-- Route Type --"
                    />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="mname" class="label">Route Name</label>
                    <input
                      type="text"
                      class="input"
                      v-model="routesObj.routeName"
                      placeholder="-- Route name --"
                    />
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="lname" class="label">Meduim</label>
                    <input
                      type="text"
                      class="input"
                      v-model="routesObj.shippingMethod"
                      placeholder="-- Shipping Method --"
                    />
                  </div>
                </div>
                <div class="input-row my-4">
                  <p class="text-lg fpnt-semibold">Routes assigned to you</p>
                </div>
                <div v-for="(routeCities, index) in routesObj.routeCities" :key="index" class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <label for="gender" class="label">Start</label>
                    <input type="text" class="input" v-model="routeCities.cityName" />
                  </div>
                  <!-- <div class="new-user-form__single-input-wrapper">
                    <label for="email" class="label">Terminate</label>
                    <input type="email" class="input" v-model="routeCities.terminal" />
                  </div> -->
                </div>
                <div class="input-row">
                  <div class="new-user-form__single-input-wrapper">
                    <table class="custom-table responsive-table">
                      <thead>
                        <tr class="shadow-table rounded-lg">
                          <th>Day</th>
                          <th>Time</th>
                          <th>SST</th>
                          <th>Express Delivery</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        
                        <tr>
                          <td>------</td>
                          <td>------</td>
                          <td>------</td>
                          <td>------</td>
                          <td>
                            <vertical-ellipsis />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-item>
    </accordion>
    <vehicle-particulars
      :show-modal="showVehicleParticulardModal"
      :particulars="fleet.fleetParticulars"
      @close-modal="showVehicleParticulardModal = false"
    />
  </div>
</template>

<script>
import VehicleParticulars from "../Modals/VehicleParticulars.vue";
export default {
  components: {
    VehicleParticulars,
  },
  data() {
    return {
      showSecurityQuestionModal: false,
      showVehicleParticulardModal: false,
      showTwoFactorModal: false,
      fleet: [],
      routesObj: {
        
      },
      routes: [],
      terminal: [],
      newUser: {
        fname: "",
        mname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        employmentType: "",
        // imageurl: "",
      },
      user: {},
      genders: ["Male", "Female"],
      languages: ["English"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      creatingUser: false,
      roles: [],
      selectedRoleId: "",
      isUploadingImage: false,
      updatingUser: false,
    };
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newUser);
    },
    routeCities() {
      let cities = this.routes.shippingService.cities;
      return JSON.parse(cities);
    },
    // user() {
    //   return JSON.parse(localStorage.getItem("loggedInUser"));
    // },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("loggedInUser"));
    console.log(this.user);
    this.getFleet();
    // this.getRoute();
    if (!this.user) {
      this.$router.push("/login");
    }
  },
  methods: {
    async getFleet() {
      try {
        const response = await this.$_getAssignedFleet(this.user.id);
        console.log(response);
        this.fleet = response.data.data;
        this.route = response.data.all_routes;
        // this.getTerminal();
        console.log(JSON.stringify(response, null, 2));
      } catch (error) {
        this.handleError(error);
      }
    },
    async getTerminal() {
      const response = await this.$_getSingleLocationDetails(this.fleet.terminals);
      this.terminal = response.data.location;
      console.log(JSON.stringify(response, null, 2));
    },
    async updateUser() {
      this.updatingUser = true;
      this.deleteExcessData();
      // endpoint expects userId not id
      this.user.userId = this.user.id;
      try {
        let response = await this.$_saveAccountOwnerInformation(this.user);
        console.log(response);
        this.$store.dispatch("saveUserDetails", response.data.updateUser);
        this.generateToast("Your information has been updated!", "success");
        this.updatingUser = false;
        this.$router.push({ name: "AccountProfile" });
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },
    deleteExcessData() {
      // removes the unneeded properties from the user object
      delete this.user.Orgs;
      delete this.user.createdAt;
      delete this.user.passwordauth;
      delete this.user.updatedAt;
      delete this.user.twoFA;
      delete this.user.securityques;
      delete this.user.onboardingtype;
      delete this.user.salt;
      delete this.user.hash;
      delete this.user.accounttype;
      delete this.user.answer;
      console.log(this.user);
    },
    async uploadImage(image) {
      // console.log(image);
      this.isUploadingImage = true;
      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");
      try {
        let response = await this.$_uploadImage(formData);
        // console.log(response);
        this.user.imageurl = response.data.secure_url;
        this.generateToast("Image uploaded", "success");
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.user.imageurl = null;
    },
    async getRoute() {
      try {
        const response = await this.$_getUserRoutes(this.user.id);
        this.routes = response.data.routeUsers;
        console.log(JSON.stringify(response, null, 2));
      } catch (error) {
        this.handleError();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.picture-upload-form {
  /* border: 1px solid #edf2ef; */
  border-radius: 10px;
  padding: 1.55rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input {
  margin-bottom: 0.5rem;
}
.new-user-form__col-three {
  padding-top: 1.25rem;
}
hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}
.input-row > div {
  width: 100%;
  padding-right: 1rem;
}

.modal-input {
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  height: 2.75rem;
  border-radius: 4px;
  display: flex;

  input {
    border: none;
    background: transparent;
  }
  span {
    align-self: center;
    padding-right: 0.5rem;
    color: #747474;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }
  .input-row div {
    width: 100%;
  }
}
</style>
